__webpack_require__.p = "http://tdemo.web2.anasource.com/";